//モデルURLを取得
const getModelURL = (nftURL) => {
  var modelURL = 'https://d2wp3sepl8g4xv.cloudfront.net/live2d/';

  // if (nftURL == 'base1') {
  //   modelURL = '/live2dmodel/test3/base.model3.json';
  //   return modelURL;
  // }

  //テンポラリー
  if (nftURL.startsWith('temp')) {
    // let baseURL = 'https://storage.googleapis.com/faceless-97bcf.appspot.com/avatar/';
    let baseURL = 'https://faceless.hiho.jp/temp/';
    let url = baseURL + nftURL + '/base.model3.json';
    return url;
  }

  //カスタムアバターの場合（作成中）
  if (nftURL.startsWith('base')) {
    // let baseURL = 'https://storage.googleapis.com/faceless-97bcf.appspot.com/avatar/';
    let baseURL = 'https://faceless.hiho.jp/custom/';
    let url = baseURL + nftURL + '/model/base.model3.json';
    return url;
  }

  //カスタムアバターの場合（作成済み）
  if (nftURL.startsWith('custom')) {
    return nftURL;
  }

  switch (nftURL) {
    case 'facelesscryptboy':
      modelURL = modelURL + 'cryptboy/cryptboy1.model3.json';
      break;
    case 'facelessmonkey':
      modelURL = modelURL + 'monkey/monkey1.model3.json';
      break;
    case 'facelessboy':
      modelURL = modelURL + 'boy/boy1.model3.json';
      break;
    case 'facelessgirl':
      modelURL = modelURL + 'girl/girl1.model3.json';
      break;

    case 'ethereum-0x23581767a106ae21c074b2276d25e5c3e136a68b-3380':
      modelURL = modelURL + 'moonbird/moonbird1.model3.json';
      break;
    case 'ethereum-0x9c8ff314c9bc7f6e59a9d9225fb22946427edc03-367':
      modelURL = modelURL + 'nouns/nouns1.model3.json';
      break;
    case 'ethereum-0x845a007d9f283614f403a24e3eb3455f720559ca-7475':
      modelURL = modelURL + 'cryptninja/cryptninja.model3.json';
      break;
    case 'ethereum-0xbce3781ae7ca1a5e050bd9c4c77369867ebc307e-5490':
      modelURL = modelURL + 'goblintown/goblintown.model3.json';
      break;
    case 'mfers':
      modelURL = modelURL + 'mfers/mfer.model3.json';
      break;
    case 'ethereum-0x82712d0052c6d8185383b5554a071c440b902992-4232':
      modelURL = modelURL + 'curiousaddy/curiousaddy.model3.json';
      break;
    case 'ethereum-0xbd3531da5cf5857e7cfaa92426877b022e612cf8-212':
      modelURL = modelURL + 'penguin/penguin2.model3.json';
      break;
    case 'penguin-sato':
      modelURL = modelURL + 'penguinsato/penguin1.model3.json';
      break;

    case 'ethereum-0x7fa162d3d44fe8d30e344cc000493da7cb6c6fbb-1696':
      modelURL = modelURL + 'bighatmonkey/monkey.model3.json';
      break;

    case 'warnah':
      modelURL = modelURL + 'newchara/character1.model3.json';
      break;

    case 'ethereum-0xe785e82358879f061bc3dcac6f0444462d4b5330-906':
      modelURL = modelURL + 'worldofwoman/World of woman.model3.json';
      break;

    case 'hakatao':
      modelURL = modelURL + 'hakatao/hakatao.model3.json';
      break;

    case 'ethereum-0xed5af388653567af2f388e6224dc7c4b3241c544-7311':
      modelURL = modelURL + 'azuki/Azuki.model3.json';
      break;

    case 'ethereum-0x704bf12276f5c4bc9349d0e119027ead839b081b-10189':
      modelURL = modelURL + 'timeless/Timeless.model3.json';
      break;

    case 'ethereum-0x97597002980134bea46250aa0510c9b90d87a587-8460':
      modelURL = modelURL + 'chainrunners/ChainRunners.model3.json';
      break;

    case 'ethereum-0xc143bbfcdbdbed6d454803804752a064a622c1f3-505':
      modelURL = modelURL + 'xcopy/Xcopy.model3.json';
      break;

    case 'ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-74174376043700788367701425876656584030327428720026632551187348737675828920321':
      modelURL = modelURL + 'Babymonkey/Babymonkey.model3.json';
      break;

    case 'ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-87383727123620161737292094198014250315741856288672271608440919165406111858689':
      modelURL = modelURL + 'lovegirl/lovegirl.model3.json';
      break;

    case 'ethereum-0x1a92f7381b9f03921564a437210bb9396471050c-4442':
      modelURL = modelURL + 'Coolcat/Coolcat.model3.json';
      break;

    // case 'ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-106212411486624036609867579056613694894334480661660538001499774945867482529793':
    //   modelURL = modelURL + 'cryptbears/cryptbears.model3.json';
    //   break;

    case 'test':
      modelURL = 'https://faceless.hiho.jp/check/168/base.model3.json';
      break;

    case 'test1':
      modelURL = '/live2dmodel/test1/base.model3.json';
      break;

    case 'test2':
      modelURL = '/live2dmodel/test2/base.model3.json';
      break;

    case 'test3':
      modelURL = '/live2dmodel/test3/base.model3.json';
      break;

    case 'test4':
      modelURL = 'https://faceless.hiho.jp/kobayashi/base.model3.json';
      break;

    case 'test5':
      modelURL = 'https://faceless.hiho.jp/hori/base.model3.json';
      break;

    case 'test6':
      modelURL = 'https://faceless.hiho.jp/mari/base.model3.json';
      break;

    case 'test7':
      modelURL = '/live2dmodel/test7/base.model3.json';
      break;

    case 'test8':
      modelURL = '/live2dmodel/test8/base.model3.json';
      break;

    case 'test9':
      modelURL = '/live2dmodel/test9/base.model3.json';
      break;

    case 'test10':
      modelURL = '/live2dmodel/test10/base.model3.json';
      break;

    case 'test11':
      modelURL = '/live2dmodel/test11/base.model3.json';
      break;

    case 'test12':
      modelURL = '/live2dmodel/test12/base.model3.json';
      break;

    case 'test13':
      modelURL = '/live2dmodel/test13/base.model3.json';
      break;

    case 'test14':
      modelURL = '/live2dmodel/test14/base.model3.json';
      break;

    case 'test15':
      modelURL = '/live2dmodel/test15/base.model3.json';
      break;

    case 'test16':
      modelURL = '/live2dmodel/test16/base.model3.json';
      break;
    case 'test17':
      modelURL = '/live2dmodel/test17/base.model3.json';
      break;
    case 'test18':
      modelURL = '/live2dmodel/test18/base.model3.json';
      break;
    case 'test19':
      modelURL = '/live2dmodel/test19/base.model3.json';
      break;

    default:
      modelURL = modelURL + nftURL + '/base.model3.json';
  }

  return modelURL;
};

export default getModelURL;
